import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService, LanguageService } from '../services';
import { AuthService } from '../services/auth/auth.service';
import { HelperService } from '../services/helper/helper.service';

/**
 * On using this guard.
 * DO NOT forget to register the component manually in helperService.
 * see implementation of 
 * this.helperService.registerCanDeactivateComponent('announcement', this);
 * ALSO do not forget to add this Guard in the CanDeactivate param of your components routing module.
 * see implementation of
 * canDeactivate: [UnsavedChangesGuard]
 */

export interface IUnsavedChangesComponent{
  hasUnsavedChanges(): boolean;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<IUnsavedChangesComponent>{

  constructor(
    private dialogService: DialogService,
    private authService: AuthService,
    private helperService: HelperService
  ) { }
  
  canDeactivate(component: IUnsavedChangesComponent, currentRoute: ActivatedRouteSnapshot, currentState:RouterStateSnapshot, nextState?:RouterStateSnapshot): boolean | Observable<boolean> {
    if (component.hasUnsavedChanges && component.hasUnsavedChanges()) {
      // return confirm('You have unsaved changes. Are you sure you want to leave?');
      return this.dialogService
        .confirm({
          title: "Warning",
          message: "Unsaved changes will be lost. Proceed?",
          hasCancel: true,
          button: "Proceed",
          buttonFn: () => { 
            // console.log("logged out from guard")
            if (nextState.url.includes('/login')) {
              this.authService.logout();
              this.helperService.clearRegisteredCanDeactivateComponents();
            };
          }
        })
    }
    return true;
  }
}
